<template>
    <div class="d-flex align-items-center text-nowrap">
        {{ $safe(row, "TrafficFine.Clause") || $safe(row, "Clause") }}
        <span
            v-if="$safe(row, 'TrafficFine.Description') || $safe(row, 'ClauseDescription')"
            v-b-tooltip.noninteractive.hover.bottom
            :title="$safe(row, 'TrafficFine.Description') || $safe(row, 'ClauseDescription')"
            class="material-icons-outlined text-muted ml-50"
        >
            info
        </span>
    </div>
</template>

<script>
import { VBTooltip } from "bootstrap-vue";
export default {
    props: {
        row: Object,
        field: Object,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
};
</script>

<style></style>
